export default [
  {
    path: '/schedule/timetable',
    name: 'PageClassTimeTable',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/schedule/PageClassTimeTable'
      ),
    meta: { modular: 26, title: '课表', keepAlive: true, info: '课表——首页' }
  },
  {
    path: '/schedule/student',
    name: 'PageStudentSchedule',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/schedule/PageStudentSchedule'
      ),
    meta: { modular: 26, title: '学生课表', info: '课表——学生课表' }
  },
  {
    path: '/schedule/student/setting',
    name: 'PageStudentScheduleSetting',
    component: () =>
      import(
        /* webpackChunkName: "others" */ '../pages/schedule/PageStudentScheduleSetting'
      ),
    meta: { modular: 26, title: '通知配置', info: '课表——学生课表配置' }
  }
]
